import * as type from "../types";
import { convertPositions } from "../../utils/helpers";
import { typeRoute, typeZone, typeRefuel, typeWarning } from "../../utils/staticData";

//pass fitBounds callback. Possible to use only FOR CARS
//(for routes functions takes different input parameter)
export const passFitBoundsCallback = callback => {
  return dispatch => {
    dispatch({
      type: type.MAP_FIT_BOUNDS,
      value: callback
    });
  };
};

export const passFitAnyBoundCallback = callback => {
  return dispatch => {
    dispatch({
      type: type.MAP_FIT_ANY_BOUNDS,
      value: callback
    });
  };
};

export const manuallyMovedOrZoomed = callback => {
  return dispatch => {
    dispatch({
      type: type.MAP_MANUALLY_MOVED_OR_ZOOMED,
      value: callback
    });
  };
};

export const fitInBounds = () => {
  return (dispatch, getState) => {
    let store = getState();
    let car = store.mapCarsReducer.selectedCar;
    let routes = store.mapRoutesReducer.selectedRoutes;
    let currentRoute = store.mapRoutesReducer.currentRoute;
    let showCurrentRoute = store.mapRoutesReducer.showCurrentRoute;
    let coords = [];
    if (currentRoute && showCurrentRoute) {
      if (currentRoute.data.length > 0) {
        currentRoute.data.forEach(route => {
          coords.push([route.lat, route.lon]);
        });
      }
    }
    if (car)
      if (car.pozycja_gps)
        coords.push([car.pozycja_gps.lat, car.pozycja_gps.lon]);
    if (routes && Array.isArray(routes))
      routes.forEach(route => {
        if (route.type === typeZone || route.type === typeRoute) {
          route.trasa.forEach(latlng => coords.push(convertPositions(latlng)));
        } else if (route.type === typeRefuel || route.type === typeWarning) {
          coords.push([route.lat, route.lon]);
        }
      });
    if (coords.length === 0) {
      let cars = store.mapCarsReducer.cars;
      if (store.mapReducer.mapToBounds && cars && cars.length > 0)
        store.mapReducer.mapToBounds(cars);
      return;
    }
    store.mapReducer.mapFitBounds(coords);
  };
};
